const config = {
  API_ENDPOINT: 'https://tranquil-plateau-50567.herokuapp.com/sbc/entries'
};

export default config;
